import { createSelector } from 'reselect'

const getCategories = state => state.categories

export const getCategoriesData = createSelector(
  [getCategories],
  state => (state ? state.data : null)
)
